import { render } from "./VersionDropdown.vue?vue&type=template&id=71c15368&ts=true"
import script from "./VersionDropdown.vue?vue&type=script&lang=ts"
export * from "./VersionDropdown.vue?vue&type=script&lang=ts"

import "./VersionDropdown.vue?vue&type=style&index=0&id=71c15368&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__